import { callPostApi, callDeleteApi, callPutApi, callGetApi } from "./api";

export async function getLocationTemplateProducts(storeId) {
      return callGetApi({ url: "locations/template-products/" + storeId });
}

export async function getCmsLocationsList(data) {
      try {
            const response = await callPostApi({ url: "locations/list", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function getCmsLocationsDetail(locationId) {
      try {
            const response = await callGetApi({ url: "locations/" + locationId });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function createCmsLocations(postData) {
      try {
            const response = await callPostApi({ url: "locations", body: postData });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function updateCmsLocations(postData, locationId) {
      try {
            const response = await callPutApi({ url: "locations/" + locationId, body: postData });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function deleteCmsLocations(id) {
      try {
            const response = await callDeleteApi({ url: "locations/" + id });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function getCmsLocationsRawDetail(locationId) {
      try {
            const response = await callGetApi({ url: "locations/locationDetail/" + locationId });
            return response;
      } catch (error) {
            throw error;
      }
}

// get locations list
export async function getLocationsList(data) {
      try {
            const response = await callPostApi({ url: "locations/location-list", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}
